export const CRISP_WEBSITE_ID = '7ef68fb9-1f4b-443f-8d93-e18160b89f8b';
